export const BLOCK_COLORS = ['#339999', '#009966', '#CCFF33', '#66CCCC', '#9966CC', '#E85C5C', '#FF9933', '#66CC99']

export function getBlockColor(index) {
    return BLOCK_COLORS[index % BLOCK_COLORS.length]
}
